import { Space, Row } from 'antd';
import { useContext, useMemo } from 'react';

import { VISITS_FILTER } from '@app/constants';
import { ClientFiltersContext } from '@app/providers';

import { ClientFilterTag } from '@pages/Clients/ClientsList/components/Filters/ClientFilterTag';

import type { NClientsList } from '@pages/Clients/ClientsList/ClientsList.types';

export const VisitsRecordsCountLabel = ({
  filterGroupIndex,
}: {
  filterGroupIndex: number;
}) => {
  const { filters, serverFilters, setFilters, setServerFilters } =
    useContext(ClientFiltersContext);

  const { MinCountRecords, MaxCountRecords } = useMemo(
    () => serverFilters.VisitsFilter?.[filterGroupIndex]?.Values?.[0],
    [serverFilters, filterGroupIndex]
  );

  return (
    <Space
      className={`visits-records-count-label${filterGroupIndex}`}
      direction="vertical"
    >
      <span>Количество записей</span>
      {(MinCountRecords !== null || MaxCountRecords !== null) && (
        <Row>
          <ClientFilterTag
            filters={filters}
            serverFilters={serverFilters}
            filtersArea={VISITS_FILTER}
            filterGroupIndex={filterGroupIndex}
            setFilters={setFilters}
            setServerFilters={setServerFilters}
            valueKey={
              'MinCountRecords' as keyof NClientsList.VisitsFilterUnitValue['MinCountRecords']
            }
          >
            {`от ${MinCountRecords}`}
          </ClientFilterTag>
          <ClientFilterTag
            filters={filters}
            serverFilters={serverFilters}
            filtersArea={VISITS_FILTER}
            filterGroupIndex={filterGroupIndex}
            setFilters={setFilters}
            setServerFilters={setServerFilters}
            valueKey={
              'MaxCountRecords' as keyof NClientsList.VisitsFilterUnitValue['MaxCountRecords']
            }
          >
            {`до ${MaxCountRecords}`}
          </ClientFilterTag>
        </Row>
      )}
    </Space>
  );
};
